import React from "react";
import {animated, useSpring} from '@react-spring/web';
import PropTypes from "prop-types";

export const Boop = ({rotation = 0, timing = 150, children}) => {
    const [isBooped, setIsBooped] = React.useState(false);
    const style = useSpring({
        display: 'inline-block',
        backfaceVisibility: 'hidden',
        transform: isBooped
            ? `rotate(${rotation}deg)`
            : `rotate(0deg)`,
    });

    React.useEffect(() => {
        // We only want to act when we're going from
        // not-booped to booped.
        if (!isBooped) {
            return;
        }
        const timeoutId = window.setTimeout(() => {
            setIsBooped(false);
        }, timing);
        // Just in case our component happens to
        // unmount while we're booped, cancel
        // the timeout to avoid a memory leak.
        return () => {
            window.clearTimeout(timeoutId);
        };
        // Trigger this effect whenever `isBooped`
        // changes. We also listen for `timing` changes,
        // in case the length of the boop delay is
        // variable.
    }, [isBooped, timing]);

    const trigger = () => {
        setIsBooped(true);
    };

    return (
        <animated.span onMouseEnter={trigger} style={style}>
            {children}
        </animated.span>
    );
};

export const ControlledBoop = (props) => {
    const {
        rotation = 0,
        timing = 150,
        triggered = false,
        triggerHandler = () => {
        },
        children
    } = props;

    const style = useSpring({
        display: 'inline-block',
        backfaceVisibility: 'hidden',
        transform: triggered
            ? `rotate(${rotation}deg)`
            : `rotate(0deg)`,
    });

    React.useEffect(() => {
        // We only want to act when we're going from
        // not-booped to booped.
        if (!triggered) {
            return;
        }
        const timeoutId = window.setTimeout(() => {
            triggerHandler(false);
        }, timing);
        // Just in case our component happens to
        // unmount while we're booped, cancel
        // the timeout to avoid a memory leak.
        return () => {
            window.clearTimeout(timeoutId);
        };
        // Trigger this effect whenever `isBooped`
        // changes. We also listen for `timing` changes,
        // in case the length of the boop delay is
        // variable.
    }, [triggered, timing, triggerHandler]);

    return (
        <animated.span style={style}>
            {children}
        </animated.span>
    );
};

ControlledBoop.propTypes = {
    rotation: PropTypes.number,
    timing: PropTypes.number,
    triggered: PropTypes.bool.isRequired,
    triggerHandler: PropTypes.func.isRequired,
}